module.exports = __webpack_public_path__ + "img/pd-right-edit.efa72ecb.svg";